export default "__VITE_ASSET__XfX$y0Qi__"